/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketShoppingCartIcon24Solid = forwardRef('MarketShoppingCartIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M0 4a1 1 0 0 1 1-1h2.73a2.875 2.875 0 0 1 2.834 2.392L6.668 6h13.9a1.75 1.75 0 0 1 1.71 2.124l-1.035 4.73A4 4 0 0 1 17.335 16H9.72a4 4 0 0 1-3.943-3.328l-.935-5.485a.976.976 0 0 1-.006-.035l-.242-1.424A.875.875 0 0 0 3.73 5H1a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M7.875 17.125a2.375 2.375 0 1 0 0 4.75 2.375 2.375 0 0 0 0-4.75Z" }),
        React.createElement("path", { d: "M17.875 17.125a2.375 2.375 0 1 0 0 4.75 2.375 2.375 0 0 0 0-4.75Z" })));
});
